import { API_BASE_URL, getImageUrl } from './config';
import { getAuthHeaders } from './utils';

export const productsAPI = {
    async list(params = {}) {
        const query = new URLSearchParams(params).toString();
        const res = await fetch(`${API_BASE_URL}/products${query ? `?${query}` : ''}`);
        if (!res.ok) throw new Error('Failed to fetch products');
        const data = await res.json();
        if (data.items) {
            data.items = data.items.map(p => ({ ...p, imageUrl: getImageUrl(p.image) }));
        }
        return data;
    },
    async getBySlug(slug) {
        const res = await fetch(`${API_BASE_URL}/products/slug/${slug}`);
        if (!res.ok) throw new Error('Product not found');
        const p = await res.json();
        return { ...p, imageUrl: getImageUrl(p.image) };
    },
    async adminList(params = {}) {
        const query = new URLSearchParams(params).toString();
        const res = await fetch(`${API_BASE_URL}/products/admin/list${query ? `?${query}` : ''}`, {
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error('Failed to fetch admin products');
        const data = await res.json();
        if (data.items) {
            data.items = data.items.map(p => ({ ...p, imageUrl: getImageUrl(p.image) }));
        }
        return data;
    },
    async create(formData) {
        const res = await fetch(`${API_BASE_URL}/products`, {
            method: 'POST',
            headers: { 'Authorization': getAuthHeaders().Authorization },
            body: formData
        });
        if (!res.ok) throw new Error('Failed to create product');
        return res.json();
    },
    async update(id, formData) {
        const res = await fetch(`${API_BASE_URL}/products/${id}`, {
            method: 'PUT',
            headers: { 'Authorization': getAuthHeaders().Authorization },
            body: formData
        });
        if (!res.ok) throw new Error('Failed to update product');
        return res.json();
    },
    async remove(id) {
        const res = await fetch(`${API_BASE_URL}/products/${id}`, {
            method: 'DELETE',
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error('Failed to delete product');
        return res.json();
    }
};




